import React, { useState, useEffect } from 'react';
import { withStyles, Button, LinearProgress } from '@material-ui/core';
import classnames from 'classnames';
import DatePicker from '../../../components/DatePicker';
import Checkbox from '@material-ui/core/Checkbox';
import { addMonths, startOfMonth, addDays } from 'date-fns';

// SERVICES
import { getClosedOrderReport, getClosedOrderReportByInvoicePeriod } from '../../../services';
import { getInitialReportMonth, monthsOptions } from '../../../helpers/constants/months';
import { Autocomplete } from '../../../components/Autocomplete';

const styles = theme => ({
  datePicker: {
    padding: 10,
  },
});

export const ClosedOrderReport = withStyles(styles)(props => {
  const { classes } = props;

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isGeneratingReport, setIsGeneratingReport] = useState(false);
  const [error, setError] = useState('');
  const [reportMonth, setReportMonth] = useState(getInitialReportMonth);

  const getClosedOrderReportAsync = useCustomDates => async () => {
    setError('');

    try {
      setIsGeneratingReport(true);
      if (useCustomDates) {
        await getClosedOrderReport({ startDate, endDate });
      } else {
        // const start = startOfMonth(new Date(reportMonth.year, reportMonth.monthIndex));
        // const end = startOfMonth(addMonths(start, 1));
        const invoicePeriod = reportMonth.label
        console.log({invoicePeriod})
        await getClosedOrderReportByInvoicePeriod({ invoicePeriod: invoicePeriod  });
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setIsGeneratingReport(false);
    }
  };

  const customDateInvalid = !startDate || !endDate;
  const selectedPeriodInvalid = !reportMonth;

  return (
    // <div className={classes.reportWrapper}>
    <div className={classnames('flex-1', 'col-center-center', 'align-stretch', 'card', 'border-left-green')}>
      <h3 style={{ marginBottom: 36 }}>
        Select a date range or an invoice period to generate and download the closed order report for that time.
      </h3>

      <div className={classnames('flex-col')}>
        <div className={classnames('row-between-center')}>
          <div className={classnames('row-center-center')}>
            <div className={classnames('col-start-start')} style={{ marginRight: 10 }}>
              <span className={classnames('text-left')}>From:</span>
              <DatePicker selected={startDate} onChange={setStartDate} className={classes.datePicker} />
            </div>
            <div className={classnames('col-start-start')} style={{ marginLeft: 10 }}>
              <span className={classnames('text-left')}>Through:</span>
              <DatePicker selected={endDate} onChange={setEndDate} className={classes.datePicker} />
            </div>
          </div>

          <Button
            variant="contained"
            style={{ backgroundColor: customDateInvalid ? '#aaa' : 'var(--jmi-blue)', color: 'white', marginLeft: 24 }}
            onClick={getClosedOrderReportAsync(true)}
            disabled={customDateInvalid || isGeneratingReport}
          >
            Get Report
          </Button>
        </div>

        <div className={classnames('row-between-center')} style={{ marginTop: 48 }}>
          <div style={{ flex: 1, minWidth: 300 }}>
            <Autocomplete
              // disabled={showGrid}
              options={monthsOptions}
              value={reportMonth}
              onChange={setReportMonth}
            />
          </div>

          <Button
            variant="contained"
            style={{ backgroundColor: selectedPeriodInvalid ? '#aaa' : 'var(--jmi-blue)', color: 'white', marginLeft: 24 }}
            onClick={getClosedOrderReportAsync(false)}
            disabled={selectedPeriodInvalid || isGeneratingReport}
          >
            Get Report
          </Button>
        </div>

        <div style={{ width: '100%', marginTop: 24 }}>
          <div
            style={{
              visibility: isGeneratingReport ? 'visible' : 'hidden',
            }}
          >
            <LinearProgress />
          </div>
          <div style={{ maxWidth: 400, color: 'red' }}>{error}</div>
        </div>
      </div>
    </div>
  );
});
